export default "__VITE_ASSET__838c73bb__"